import { 
    FaWordpress, 
    FaShoppingCart, 
    FaCode, 
    FaServer, 
    FaPaintBrush,
    FaShopify
} from "react-icons/fa";
import { RiPagesFill, RiLayout3Fill } from "react-icons/ri";
import { MdApi } from "react-icons/md";

const data = [
    {
        id: 1,
        icon: <FaWordpress />,
        title: 'Custom WordPress Development',
        desc: "Custom-built, mobile-responsive, and high-performance WordPress websites tailored to your business goals."
    },
    {
        id: 2,
        icon: <FaShopify />,
        title: 'Shopify Theme Customization',
        desc: "Advanced Shopify theme customization using Liquid & JSON templates with custom sections, blocks, and UI enhancements."
    },
    {
        id: 3,
        icon: <FaShoppingCart />,
        title: 'Shopify Store Setup & Optimization',
        desc: "Complete Shopify store setup, product configuration, checkout optimization, and performance improvements."
    },
    {
        id: 4,
        icon: <RiPagesFill />,
        title: 'Theme & Page Builder Customization',
        desc: "Expert customization using Elementor, WPBakery, FSE, and modern WordPress themes for flexible layouts."
    },
    {
        id: 5,
        icon: <FaCode />,
        title: 'Plugin Development & Customization',
        desc: "Custom WordPress plugin development and advanced customization using clean, OOP-based architecture."
    },
    {
        id: 6,
        icon: <FaShoppingCart />,
        title: 'WooCommerce Solutions',
        desc: "Complete WooCommerce setup, custom functionality, checkout optimization, and scalable eCommerce solutions."
    },
    {
        id: 7,
        icon: <MdApi />,
        title: 'API & Payment Gateway Integration',
        desc: "Secure integration of third-party APIs and payment gateways for WordPress and Shopify platforms."
    },
    {
        id: 8,
        icon: <FaServer />,
        title: 'Backend Development & Optimization',
        desc: "Performance optimization, security hardening, and backend improvements to ensure scalability and speed."
    },
    {
        id: 9,
        icon: <RiLayout3Fill />,
        title: 'HTML to WordPress Conversion',
        desc: "Convert static HTML/CSS designs into dynamic, SEO-friendly, and easy-to-manage WordPress websites."
    },
    {
        id: 10,
        icon: <FaPaintBrush />,
        title: 'Website Redesign & Maintenance',
        desc: "Modern redesigns, bug fixes, updates, and ongoing maintenance to keep your website secure and up to date."
    }
];

export default data;
